import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroBusiness";
import Cta from "../components/Cta";
import Feature from "../components/Features/FeatureIntegrate";


const Integrate = () => (
    <>
        <Seo
            title="integrate.io 데이터 통합 플랫폼"
            description="노코드 데이터 파이프라인과 ETL·리버스 ETL. 드래그 앤 드롭으로 데이터를 변환하고 필요한 시스템에 전송합니다."
            path="/integrate"
        />
        <Hero />
        <Feature />
        <Cta preset="contact" product="Integrate" />
        <Footer />
    </>
);

export default Integrate;